import { Box, Tooltip, TooltipProps } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  title: ReactNode;
  children: ReactNode;
  placement?: TooltipProps["placement"];
};

export default function TooltipIconContainer({
  title,
  placement = "bottom",
  children,
}: Props) {
  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: "168px",
            backgroundColor: "rgba(58, 58, 65, 0.95) !important",
            ".MuiTooltip-arrow": {
              color: "rgba(58, 58, 65, 0.95) !important",
            },
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignContent: "center",
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
}
